import { render, staticRenderFns } from "./InputSearchBar.vue?vue&type=template&id=2ca2f2b9"
import script from "./InputSearchBar.vue?vue&type=script&lang=js"
export * from "./InputSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports